import { render } from "./SmallText.vue?vue&type=template&id=04986367&scoped=true&ts=true"
import script from "./SmallText.vue?vue&type=script&lang=ts"
export * from "./SmallText.vue?vue&type=script&lang=ts"

import "./SmallText.vue?vue&type=style&index=0&id=04986367&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04986367"]])

export default __exports__